"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _class;

var Survey = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Survey, _Activity);

  function Survey() {
    babelHelpers.classCallCheck(this, Survey);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Survey).apply(this, arguments));
  }

  babelHelpers.createClass(Survey, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      if (this.readOnly) {
        var d = this.$('.activity-body .description');
        this.$('.activity-body').empty().append("<div class='row'></div>");

        if (d.length && d.text()) {
          this.$('.activity-body .row').append(d);

          if (d.children().length == 0) {
            var dt = d.text();
            d.html("<p></p>").find('p').text(dt);
          }
        }

        if (this.endActivityState.result.declinedSurvey) {
          this.$('.activity-body .row').append("\n\t\t\t\t\t<div class='section-item col-xs-12 col-sm-12 col-md-10 col-md-offset-1'>\n\t\t\t\t\t\t<p>You declined to take this survey.</p>\n\t\t\t\t\t</div>\n\t\t\t\t");
        } else {
          this.endActivityState.result.surveyResponse.forEach(function (item) {
            var type = item.type,
                value = item.value,
                question = item.question,
                answer = item.answer;

            switch (type) {
              case 'Text':
              case 'Header':
                var p = document.createElement(type == 'Text' ? 'p' : 'div');
                p.textContent = value;
                var col = document.createElement('div');
                col.className = 'col-sm-8 col-sm-offset-2 col-xs-12';
                col.appendChild(p);

                _this.$('.activity-body > .row').append(col);

                break;

              default:
                if (question) {
                  var p = document.createElement('div');
                  p.innerHTML = "\n\t\t\t\t\t\t\t\t\t<p style='margin-bottom: 1.25em;'>\n\t\t\t\t\t\t\t\t\t\t<b></b>\n\t\t\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t\t\t<span ".concat(answer ? '' : 'style="font-style: italic;"', "></span>\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t");
                  p.querySelector('b').textContent = question;
                  p.querySelector('span').textContent = answer || "(You did not answer this question.)";
                  var col = document.createElement('div');
                  col.className = 'col-sm-8 col-sm-offset-2 col-xs-12';
                  col.appendChild(p);

                  _this.$('.activity-body > .row').append(col);
                }

                break;
            }
          });
        }

        this.activityComplete();
      }

      this.addEventListener('activityComplete', function (event) {
        _this.doNextActivity();

        event.preventDefault();
      });
      this.addEventListener('startedActivity', this._surveyStarted);
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      this.startActivity();
    }
  }, {
    key: "_surveyStarted",
    value: function _surveyStarted(_ref) {
      var _this2 = this;

      var activity = _ref.activity;
      var d = this.$('.activity-body .description');
      this.$('.activity-body .row').remove();
      this.$('.activity-body').append("<form class='row'></form>");

      if (d.length && d.text()) {
        this.$('.activity-body .row').append(d);

        if (d.children().length == 0) {
          var dt = d.text();
          d.html("<p></p>").find('p').text(dt);
        }
      }

      this.showActivityTitle();

      var e = function e(t) {
        return String(t).replace(/[&<"']/g, function (v) {
          return "&#".concat(v.charCodeAt(0), ";");
        });
      };

      var m = activity.details.Survey.details.map(function (item, i) {
        switch (item.type) {
          case 'Text':
          case 'Header':
            return "\n\t\t\t\t\t\t<".concat(type == 'Text' ? 'p' : 'div', ">").concat(e(item.value), "</").concat(type == 'Text' ? 'p' : 'div', ">\n\t\t\t\t\t");

          case 'Dropdown':
            if (/i(Phone|Pod)/.test(navigator.userAgent)) {
              return "\n\t\t\t\t\t\t\t<div class='radio-group' data-index='".concat(i, "'>\n\t\t\t\t\t\t\t\t<label>").concat(e(item.title)).concat(item.required ? ' *' : '', "</label>\n\t\t\t\t\t\t\t\t").concat(item.values.map(function (value, j) {
                return "\n\t\t\t\t\t\t\t\t\t\t<div class='radio'>\n\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type='radio' name='survey_".concat(i, "' id='survey_").concat(i, "_").concat(j, "' value='").concat(e(value), "' ").concat(item.required ? 'required' : '', ">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>").concat(e(value), "</span>\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t");
              }).join(''), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t");
            }

            return "\n\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t<label for='survey_".concat(i, "'>").concat(e(item.title)).concat(item.required ? ' *' : '', "</label>\n\t\t\t\t\t\t\t<select id='survey_").concat(i, "' class='form-control' size='1' data-index='").concat(i, "'>\n\t\t\t\t\t\t\t\t<option value=''>- select -</option>\n\t\t\t\t\t\t\t\t").concat(item.values.map(function (value) {
              return "<option value='".concat(e(value), "'>").concat(e(value), "</option>");
            }).join(''), "\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t");

          case 'Textarea':
            return "\n\t\t\t\t\t\t<div class='form-group'>\n\t\t\t\t\t\t\t<label for='survey_".concat(i, "'>").concat(e(item.title)).concat(item.required ? ' *' : '', "</label>\n\t\t\t\t\t\t\t<textarea id='survey_").concat(i, "' rows='4' class='form-control").concat(item.required ? ' required' : '', "' ").concat(item.required ? 'required' : '', " data-index='").concat(i, "'></textarea>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t");
        }
      }).filter(function (v) {
        return !!v;
      }).map(function (v) {
        return "<div class='col-sm-8 col-sm-offset-2 col-xs-12'>".concat(v, "</div>");
      }).join('');
      this.$('.activity-body > row').append(m);

      if (activity.details.Survey.canSkip) {
        var n = document.createElement('div');
        n.className = 'col-sm-8 col-sm-offset-2 col-xs-12';
        n.innerHTML = "\n\t\t\t\t<div class='checkbox'>\n\t\t\t\t\t<label>\n\t\t\t\t\t\t<input type='checkbox' id='surveySkip'>\n\t\t\t\t\t\t<span>".concat(e(activity.details.Survey.declineSurveyText), "</span>\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t");
        this.$('.activity-body > row').append(n);
      }

      var f = document.createElement('div');
      f.className = 'col-sm-8 col-sm-offset-2 col-xs-12';
      this.$('.activity-body').append(f);
      this.showButton('Continue');
      this.addEventListener('buttonClick', function (event) {
        if (document.activeElement.is(':input')) {
          $(document.activeElement).one('blur', function (event) {
            _this2.dispatchEvent(_this2._event('buttonClick'));
          });
          return;
        }

        if (activity.details.Survey.canSkip) {
          if ($('#surveySkip').is(':checked')) {
            _this2.endActivity({
              declinedSurvey: true
            });

            return;
          }
        }

        var surveyDetail = [],
            ok = true;
        activity.details.Survey.details.forEach(function (item, index) {
          if (!ok) return;
          var control = activity.$(".form-control[data-index=\"".concat(index, "\"]"));
          if (!control.length && item.type == 'Dropdown') control = activity.$(".radio-group[data-index=\"".concat(index, "\"]"));

          switch (item.type) {
            case 'Dropdown':
              if (control.is('.radio-group')) {
                if (control.find('input[type=radio]').prop('required')) {
                  if (control.find('input:checked').length == 0) {
                    ok = false;
                    var end = $(document).scrollTop(),
                        start = control.offset().top - 50;
                    var d = end - start;
                    var tt = new _animationHelper.default(250, 'ease-in-out', function (percent) {
                      var p = end - d * percent;
                      $(documemt).scrollTop(p);
                    });
                    tt.start();
                    var rb = control.find('input').eq(0).parent().tooltip({
                      animation: true,
                      delay: 0,
                      html: false,
                      placement: 'top',
                      title: 'Please answer this question',
                      trigger: 'manual'
                    }).tooltip('show');
                    var isGone = false;
                    rb.on('hidden.bs.tooltip', function () {
                      isGone = true;
                      rb.tooltip('destroy');
                    });
                    setTimeout(function () {
                      if (!isGone) rb.tooltip('hide');
                    }, 5000);

                    _this2.stopButtonSpin();

                    return;
                  }
                }

                var selected = control.find('input:checked')[0];
                var question = item.title,
                    answer = selected ? selected.value : '';
                surveyDetail.push({
                  question: question,
                  answer: answer
                });
                return;
              }

            case 'Textarea':
              if (control.prop('required')) {
                if (!control.val()) {
                  ok = false;
                  control.focus();
                  control.tooltip({
                    animaion: true,
                    delay: 0,
                    html: fale,
                    placement: 'top auto',
                    title: 'Please answer this question.',
                    trigger: 'manual'
                  }).tooltip('show');
                  control.parents('.form-group')[0].scrollIntoView();
                  var isGone = false;
                  control.on('hidden.bs.tooltip', function () {
                    isGone = true;
                    control.tooltip('destroy');
                  });
                  setTimeout(function () {
                    if (!isGone) control.tooltip('hide');
                  }, 5000);

                  _this2.stopButtonSpin();

                  return;
                }
              }

              surveyDetail.push({
                question: item.title,
                answer: control.val()
              });
              return;

            default:
              surveyDetail.push({
                type: item.type,
                value: item.value
              });
          }
        });

        if (ok) {
          _this2.endActivity({
            surveyResponse: surveyDetail
          });
        }
      });
    }
  }]);
  return Survey;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_surveyStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_surveyStarted"), _class.prototype)), _class);
exports.default = Survey;